import Skeleton from '@mui/material/Skeleton'

const skeletonGrid = []
for (let i = 0; i < 6; i++) {
  skeletonGrid.push(
    <Skeleton variant="rectangular" className="w-full h-32 rounded-lg" />
  )
}

export const LoadingStudentsReport = () => (
  <>
    <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-8 uppercase py-12">
      {skeletonGrid}
    </div>
    <Skeleton variant="rectangular" className="w-full h-32 rounded-lg" />
  </>
)
